(function () {
	'use strict';

	/**
	 * @ngdoc type
	 * @name mx.shell.WizardButton
	 * @module mx.shell
	 *
	 * @description
	 * Type that contains ultimate information about wizard page.
	 * A constructor accepts `title`, `isVisible` and `callback` parameters that may contain fields to extend corresponding properties. Created like:
	 * ```javascript
	 var button = new MxWizardButton('Next', true, callbackFunction);
	 * ```
	 *
	 * @property {string} title - Gets or sets wizard's title.<br>Default value is `to be titled`
	 * @property {boolean} isVisible - Gets or sets button's visibility.<br>Default value is `true`
	 * @property {function} callback - A function to be called when button is pressed. Wizard shared object will be passed
	 * @property {boolean} isDisabled - Gets or sets flag if button is disabled.<br>Default value is `false`
	 */
	angular.module('mx.shell').factory('mx.shell.WizardButton', [
		function wizardButtonFactory() {
			return WizardButton;
		},
	]);

	function WizardButton(title, isVisible, callback, isDisabled) {
		Object.defineProperty(this, 'isVisible', {
			writable: true,
			value: isVisible !== false,
		});
		Object.defineProperty(this, 'isDisabled', {
			writable: true,
			value: isDisabled === true,
		});
		Object.defineProperty(this, 'title', {
			writable: true,
			value: title || 'to be titled',
		});
		Object.defineProperty(this, 'callback', {
			writable: true,
			value: callback,
		});
	}
})();
